import { SheqManagerAudit } from "./components/SheqManagerAudit";

export default SheqManagerAudit;